import ClickableHighlightedText from "./ClickableHighlightedText";
export default ClickableHighlightedText;
